import axios from "axios";

const state = {
  roles: [],
  permisos: [],
  usuarios: [],
};

const mutations = {
  SET_ROLES(state, items) { state.roles = items; },
  SET_PERMISOS(state, items) { state.permisos = items; },
  SET_USUARIOS(state, items) { state.usuarios = items; },
  UPDATE_USUARIO(state, usuario) {
    const idx = state.usuarios.findIndex((u) => u.id === usuario.id);
    if (idx !== -1) state.usuarios.splice(idx, 1, usuario);
  },
};

const actions = {
  async fetchRoles({ commit }) {
    const { data } = await axios.get("/api/roles");
    commit("SET_ROLES", data);
    return data;
  },
  async fetchPermisos({ commit }) {
    const { data } = await axios.get("/api/permisos");
    commit("SET_PERMISOS", data);
    return data;
  },
  async fetchUsuarios({ commit }) {
    const { data } = await axios.get("/api/usuarios");
    commit("SET_USUARIOS", data);
    return data;
  },
  async guardarRol({ dispatch }, rol) {
    const payload = { name: rol.name, permisos: rol.permisos };
    if (rol.id) {
      await axios.put(`/api/roles/${rol.id}`, payload);
    } else {
      await axios.post("/api/roles", payload);
    }
    return dispatch("fetchRoles");
  },
  async deleteRol({ dispatch }, id) {
    await axios.delete(`/api/roles/${id}`);
    return dispatch("fetchRoles");
  },
  async asignarRoles({ commit, dispatch }, { id, roles }) {
    const { data } = await axios.put(`/api/usuarios/${id}/roles`, { roles });
    commit("UPDATE_USUARIO", data);
    dispatch("fetchRoles");
    return data;
  },
};

const getters = {
  roles: (state) => state.roles,
  permisos: (state) => state.permisos,
  usuarios: (state) => state.usuarios,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
